<template>
    <slot v-if="config.developer.enabled" />
</template>

<script setup lang="ts">
import { useStoreConfig } from '@/stores/app/config';

const config = useStoreConfig();
</script>
